import React from "react";
import { HeartHandshakeIcon, ShoppingBasketIcon, SparklesIcon, TimerIcon } from "lucide-react";
import { Reveal } from "../ui/Reveal";
const pillars = [{
  icon: ShoppingBasketIcon,
  title: "Accesible",
  text: "Ingredientes locales, precio bajo."
}, {
  icon: SparklesIcon,
  title: "Deliciosa",
  text: "Sin compromiso en sabor."
}, {
  icon: HeartHandshakeIcon,
  title: "Saludable",
  text: "Sin ingredientes cuestionables."
}, {
  icon: TimerIcon,
  title: "Viable",
  text: "Tiempo real en la cocina, no promesas falsas."
}];
export function CredibilitySection() {
  return <section className="bg-white py-20 lg:py-28" data-id="element-115" data-mp="1uu9fg6vu8lbm">
      <div className="mx-auto grid max-w-6xl items-start gap-14 px-5 lg:grid-cols-2" data-id="element-116" data-mp="1usyai3qnp7ix">
        <div data-id="element-117" data-mp="1pu4xsdj71kjt">
          <Reveal data-id="element-118" data-mp="1pueqw9zjc7tq">
            <h2 className="font-display text-3xl font-bold leading-tight text-cocoa sm:text-5xl" data-id="element-119" data-mp="1pxamhrnwukf0">Quién Está Detrás de Esto</h2>
          </Reveal>
          <Reveal delay={0.05} className="mt-6 space-y-4 text-lg leading-relaxed text-cocoa-light" data-id="element-120" data-mp="efhwslohusfi">
            <p data-id="element-121" data-mp="3v23fawvnyrq8">
              El Pack Dulce Saludable no nace de la nada. Viene de años de trabajo nutritivo, cientos de pruebas fallidas, y feedback real de{" "}
              <b className="text-cocoa" data-id="element-122" data-mp="3ty2od19vb7h">más de 2,000 mujeres en Latam, España y USA</b> que ya habían saltado a este sistema.
            </p>
            <p data-id="element-123" data-mp="3r08h41914ugo">Hemos trabajado con nutricionistas, pediatras y reposteros profesionales para asegurar que cada receta:</p>
          </Reveal>
          <Reveal delay={0.1} className="mt-8 border-l-4 border-gold pl-5" data-id="element-124" data-mp="3casvezocvf7u">
            <p className="text-lg font-semibold text-cocoa" data-id="element-125" data-mp="3h3m05njtqnjx">
              Esto no es un recetario genérico de internet. Es un sistema probado, testado, y validado por miles de mujeres reales.
            </p>
          </Reveal>
        </div>

        <dl className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2 lg:pt-4" data-id="element-126" data-mp="37aoamxgezybt">
          {pillars.map(({
          icon: Icon,
          title,
          text
        }, i) => <Reveal key={title} delay={i * 0.05} className="flex gap-4 border-t border-blush pt-5" data-id="element-127" data-mp="2ybb001gk13pi" data-mpi={i}>
              <Icon className="h-6 w-6 shrink-0 text-berry" data-id="element-128" data-mp="13x5tx1jsywf8" />
              <div data-id="element-129" data-mp="z5fgunthduk4">
                <dt className="font-display text-xl font-bold text-cocoa" data-id="element-130" data-mp="z4w03afkhc7o">Sea {title.toLowerCase()}</dt>
                <dd className="mt-1 text-cocoa-light" data-id="element-131" data-mp="v30ye4tq4wtd">{text}</dd>
              </div>
            </Reveal>)}
        </dl>
      </div>
    </section>;
}